export default {
  mounted(el) {
    // Find the closest ion-content parent and reset its scroll
    setTimeout(() => {
      const resetIonContentScroll = () => {
        // Find all ion-content elements
        const ionContents = document.querySelectorAll('ion-content')
        ionContents.forEach((content) => {
          if (content.scrollToTop) {
            content.scrollToTop(0)
          }
        })
      }

      resetIonContentScroll()
    }, 100) // Small delay to ensure component is fully rendered
  }
}
